import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';
import { TEMAS_ENTREVISTA, fechaHora, poli } from './poliApi';

/**
 * Lectura del informe (ultima version). Gerencia puede dejar una observacion; el poligrafista la
 * atiende enviando una version nueva. Si quien lo abre es el cliente, el servidor pasa la prueba a
 * "Visualizado" y deja la lectura en la bitacora.
 */
export const ContenidoInforme = ({ c, campos }) => (
    <div className="flex flex-column gap-3">
        <section>
            <h6 className="mb-1">Historial de poligrafia</h6>
            {c.historial && (c.historial.primeraPrueba ? 'Es su primera prueba.' : `Ultima prueba: ${c.historial.fechaUltima || '—'}`)}
        </section>
        <section>
            <h6 className="mb-1">Entrevista</h6>
            {TEMAS_ENTREVISTA.map((t) => (
                <div key={t.clave} className="mb-2">
                    <b>{t.titulo}:</b> <span style={{ whiteSpace: 'pre-wrap' }}>{(c.entrevista && c.entrevista[t.clave]) || '—'}</span>
                </div>
            ))}
        </section>
        <section>
            <h6 className="mb-1">Admisiones</h6>
            {(c.admisiones || []).filter((a) => (a || '').trim()).length === 0 ? 'Sin admisiones.' : (
                <ol type="A" className="m-0 pl-4">{c.admisiones.filter((a) => (a || '').trim()).map((a, i) => <li key={i} style={{ whiteSpace: 'pre-wrap' }}>{a}</li>)}</ol>
            )}
        </section>
        <section>
            <h6 className="mb-1">Preguntas y resultados</h6>
            {(c.preguntas || []).map((q, i) => (
                <div key={i} className="mb-2">
                    <b>{i + 1}. {q.pregunta}</b><br />
                    Respuesta: {q.respuesta} · <b style={{ color: q.resultado === 'PASO' ? '#1f8a4c' : '#c2381f' }}>{q.resultado === 'PASO' ? 'Paso' : 'No paso'}</b>
                </div>
            ))}
        </section>
        {(campos || []).length > 0 && (
            <section>
                <h6 className="mb-1">Campos adicionales</h6>
                {campos.map((f) => (
                    <div key={f.campo_id}><b>{f.etiqueta}:</b> {(c.adicionales && c.adicionales[f.campo_id]) || '—'}</div>
                ))}
            </section>
        )}
    </div>
);

const InformeVista = ({ pruebaId, visible, esGerencia, alCerrar }) => {
    const [d, setD] = useState(null);
    const [obs, setObs] = useState('');
    const [error, setError] = useState('');

    const cargar = () => poli(`/pruebas/${pruebaId}/informe`).then(setD).catch((e) => setError(e.message));

    useEffect(() => {
        setD(null);
        setError('');
        if (visible && pruebaId) cargar();
    }, [visible, pruebaId]); // eslint-disable-line react-hooks/exhaustive-deps

    const observar = async () => {
        try {
            await poli(`/pruebas/${pruebaId}/informe/observaciones`, 'POST', { texto: obs });
            setObs('');
            cargar();
        } catch (e) {
            setError(e.message);
        }
    };

    return (
        <Dialog header={d ? `Informe ${d.prueba.codigo}${d.version ? ` · version ${d.version}` : ''}` : 'Informe'} visible={visible}
            style={{ width: 'min(56rem, 96vw)' }} onHide={alCerrar}>
            {error && <Message severity="error" text={error} />}
            {d && d.contenido && (
                <div className="flex flex-column gap-3">
                    <div className="text-700">
                        {d.prueba.apellidos} {d.prueba.nombres} · C.I. {d.prueba.cedula} · {d.prueba.compania} · {d.prueba.tipo_prueba || ''}
                    </div>
                    <ContenidoInforme c={d.contenido} campos={d.campos} />
                    {d.observaciones && (
                        <section className="border-top-1 surface-border pt-3">
                            <h6 className="mb-1">Observaciones de Gerencia</h6>
                            {d.observaciones.length === 0 && <small className="text-600">Sin observaciones.</small>}
                            {d.observaciones.map((o) => (
                                <div key={o.observacion_id} className="mb-2">
                                    <small className="text-600">{fechaHora(o.fecha)} · {o.usuario} · sobre la version {o.version}
                                        {o.atendida_version ? ` · atendida en la version ${o.atendida_version}` : ' · pendiente'}</small>
                                    <div>{o.texto}</div>
                                </div>
                            ))}
                            {esGerencia && (
                                <div className="flex flex-column gap-2 mt-2">
                                    <label htmlFor="inf-obs">Nueva observacion para el poligrafista</label>
                                    <InputTextarea id="inf-obs" rows={2} autoResize value={obs} onChange={(e) => setObs(e.target.value)} spellCheck lang="es" />
                                    <Button label="Devolver con observacion" icon="pi pi-reply" className="align-self-start" disabled={obs.trim().length < 5} onClick={observar} />
                                </div>
                            )}
                        </section>
                    )}
                    {(d.versiones || []).length > 1 && (
                        <small className="text-600">Versiones: {d.versiones.map((v) => `${v.version} (${fechaHora(v.fecha)})`).join(' · ')}</small>
                    )}
                </div>
            )}
        </Dialog>
    );
};

export default InformeVista;
